import { SearchParams } from '../enterprises_search'

/**
 * 検索パラメータをURLSearchParamsに変換
 */
export const searchParamsToURLParams = (params: SearchParams): URLSearchParams => {
  const urlParams = new URLSearchParams()

  if (params.keyword) urlParams.set('keyword', params.keyword)
  if (params.enterpriseCategory) urlParams.set('enterpriseCategory', params.enterpriseCategory)
  if (params.businessCategory) urlParams.set('businessCategory', params.businessCategory)
  if (params.location) urlParams.set('location', params.location)
  if (params.companySize) urlParams.set('companySize', params.companySize)
  if (params.capital) urlParams.set('capital', params.capital)
  
  // SDGsカテゴリーは配列なので特別な処理
  if (params.sdgsCategories && params.sdgsCategories.length > 0) {
    params.sdgsCategories.forEach(cat => {
      urlParams.append('sdgsCategories', cat)
    })
  }

  return urlParams
}

/**
 * URLSearchParamsを検索パラメータに変換
 */
export const urlParamsToSearchParams = (urlParams: URLSearchParams): SearchParams => {
  return {
    keyword: urlParams.get('keyword') || '',
    enterpriseCategory: urlParams.get('enterpriseCategory') || '',
    businessCategory: urlParams.get('businessCategory') || '',
    location: urlParams.get('location') || '',
    companySize: urlParams.get('companySize') || '',
    capital: urlParams.get('capital') || '',
    sdgsCategories: urlParams.getAll('sdgsCategories') || [],
  }
}

/**
 * ソートパラメータをURLに追加・取得
 */
export const getSortFromURL = (urlParams: URLSearchParams): string | null => {
  return urlParams.get('sort')
}

export const setSortToURL = (urlParams: URLSearchParams, sort: string): void => {
  urlParams.set('sort', sort)
}